import { isNil } from 'lodash';
import { useCallback } from 'react';
import { ScrollView, TextInput, findNodeHandle } from 'react-native';
import { useDebouncedCallback } from 'use-debounce';
import { grid } from '@shared/styles';

const keyboardAnimationDuration = 250;
const keyboardOffset = grid(20);

export function useScrollTextInputIntoView() {
  return useCallback(() => {
    scrollActiveElementIntoView();
  }, []);
}

export function useDebouncedScrollTextInputIntoView(delay = keyboardAnimationDuration) {
  const scrollIntoView = useScrollTextInputIntoView();
  const [debouncedScrollIntoView] = useDebouncedCallback(scrollIntoView, delay);
  return debouncedScrollIntoView;
}

function scrollActiveElementIntoView() {
  document.activeElement?.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'nearest',
  });
}

export function scrollToKeyboard(scrollView?: ScrollView | null) {
  const currentlyFocusedInput = TextInput.State.currentlyFocusedInput();
  if (!isNil(scrollView) && !isNil(currentlyFocusedInput)) {
    const nodeHandle = findNodeHandle(currentlyFocusedInput);
    scrollView.scrollResponderScrollNativeHandleToKeyboard(nodeHandle, keyboardOffset, true);
  }
}
